import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Mortgage } from '../../dialer/model/model.mortgage';

@Component({
  selector: 'app-listmsg',
  templateUrl: './listmsg.component.html',
  styleUrls: ['./listmsg.component.css']
})

export class ListmsgComponent implements OnInit {
  name:string;
  status:string;
  image:string;
  
  @Input() data:any;
  @Output() leadclick: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    console.log("this lead component"+JSON.stringify(this.data));
    this.name=this.data.name;
    this.status=this.data.message;
    this.image=this.data.image;
  }

  onClick()
  {
    this.leadclick.emit(this.data);
    //console.log("heloo");
  }
}
